/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumPlus: {
    name: 'big-medium-plus';
    data: string;
} = {
    name: 'big-medium-plus',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M120 59H69V8a5 5 0 0 0-10 0v51H8a5 5 0 0 0 0 10h51v51a5 5 0 0 0 10 0V69h51a5 5 0 0 0 0-10"/></svg>`,
};
